import Constants from "@husky-hrc/Utilities/Constants";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteSetAddToListModalIsOpen,
} from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";

interface Parameter {
    productInfos?: Omit<ProductInfo, "productDetailPath">[];
    modalIsOpen: boolean;
    configId?: string;
}

type HandlerType = Handler<Parameter>;

export const HuskyDispatchCompleteSetAddToListModalIsOpen: HandlerType = props => {
    props.dispatch({
        type: [Constants.Actions.CompleteSetAddToListModalIsOpen],
        isOpen: props.parameter.modalIsOpen,
        productInfos: props.parameter.productInfos,
        configId: props.parameter.configId,
    } as any);
};

replaceInChain(chain, DispatchCompleteSetAddToListModalIsOpen, HuskyDispatchCompleteSetAddToListModalIsOpen);
